export enum InstitutionPresentationStatus {
  // Hubler never applied to this institution
  CREATE_APPLICATION = 'CREATE_APPLICATION',
  // Hubler started a network application to this institution but didn't finish it
  RESUME_APPLICATION = 'RESUME_APPLICATION',
  // Hubler has sent a network application to this institution and it has been accepted
  HUBLER_ACCEPTED_IN_NETWORK = 'HUBLER_ACCEPTED_IN_NETWORK',
  // Hubler has sent a network application to this institution and it has been refused
  HUBLER_REFUSED_BY_NETWORK = 'HUBLER_REFUSED_BY_NETWORK',
  // Hubler has sent a network application to this institution and it's incomplete
  APPLICATION_INCOMPLETE = 'APPLICATION_INCOMPLETE',
  // Hubler has sent a network application to this institution and it's in progress
  APPLICATION_IN_PROGRESS = 'APPLICATION_IN_PROGRESS',
  // Hubler has been disabled by the network
  HUBLER_DISABLED_BY_NETWORK = 'HUBLER_DISABLED_BY_NETWORK',
  // Hubler disabled the institution
  INSTITUTION_DISABLED_BY_HUBLER = 'INSTITUTION_DISABLED_BY_HUBLER',
  // Hubler already works with this institution via an agency therefore cannot apply to it
  ALREADY_WORKING_WITH_AGENCY = 'ALREADY_WORKING_WITH_AGENCY',
  // Hubler already works with this institution via hublo pool therefore cannot apply to it
  ALREADY_WORKING_WITH_HUBLO_POOL = 'ALREADY_WORKING_WITH_HUBLO_POOL',
}
